import React, { useState, useEffect } from 'react'
import { Link, makeStyles } from '@material-ui/core'

const pathHabilitada = [
  '/laridae',
  '/laridae/',
  '/laridae/tarifasvigentes',
  '/laridae/manualdeservicio',
  '/laridae/alcancedesig',
  '/laridae/politicaempresa'
]

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: '#1c2a78cc'
  },
  link: {
    padding: '8px',
    margin: '0 2px',
    color: 'white',
    '&:hover': {
      color: '#bdbdbd'
    }
  }
}))

const MenuIntitucional = () => {
  const classes = useStyles()
  const [menuInstitucional, setMenuIntitucional] = useState(false)

  const pathname = window.location.pathname

  useEffect(() => {
    setMenuIntitucional(pathHabilitada.includes(pathname))
  }, [pathname, setMenuIntitucional])

  return (
    <> { menuInstitucional &&
    <div className={classes.root} >
      <Link className={classes.link} href='/laridae/tarifasvigentes' onClick={() => {}}>
                        Tarifas vigentes
      </Link>

      <Link className={classes.link} href='/laridae/manualdeservicio' onClick={() => {}}>
                        Manual de servicio
      </Link>
      <Link className={classes.link} href='/laridae/alcancedesig'>
                        Alcance de SIG
      </Link>
      <Link className={classes.link} href='/laridae/politicaempresa' onClick={() => {}}>
                        Politica de la empresa
      </Link>
    </div>
    }
    </>

  )
}

export default MenuIntitucional
